import { Chip, TruncateText } from '@mint-lib/tw-components';

import { Tooltip } from '../atoms/Tooltip.jsx';

type CollaboratorsListProps = Readonly<{
  collaborators: { email: string }[];
}>;

export function CollaboratorsList({ collaborators }: CollaboratorsListProps) {
  if (!collaborators.length) {
    return null;
  }

  const [firstCollaborator, ...restCollaborators] = collaborators;

  const restCollaboratorsTooltipContent = (
    <div>
      {restCollaborators.map((collaborator) => (
        <div key={collaborator.email}>{collaborator.email}</div>
      ))}
    </div>
  );

  return (
    <div className="flex max-w-full items-center gap-2">
      <TruncateText>{firstCollaborator.email}</TruncateText>
      {restCollaborators.length > 0 && (
        <Tooltip description={restCollaboratorsTooltipContent}>
          <Chip variant="outline" color="secondary" size="small">
            {`+${restCollaborators.length}`}
          </Chip>
        </Tooltip>
      )}
    </div>
  );
}
